import { Group, GroupToPermissionMapping, Permission } from "@/permissions";
import { createSelector } from "@reduxjs/toolkit";
import { RootAuthState } from "./auth.slice";

export const userIdSelector = (state: RootAuthState) => state.auth.userId!;

export const userSelector = createSelector(
  (state: RootAuthState) => state.auth,
  auth => {
    if (!auth.user) {
      // Very unlikely to happen, but if it does we want to catch it.
      console.error("Tried to load user from state, before it was loaded");
    }
    return auth.user!;
  },
);

export const tokenSelector = (state: RootAuthState) => state.auth.token!;
export const userPermissionsSelector = createSelector(
  (state: RootAuthState) => state.auth,
  (auth): Permission[] => {
    const ls: Permission[] = [];
    for (const group of auth.groups || []) {
      if (group in GroupToPermissionMapping) {
        ls.push(GroupToPermissionMapping[group as Group]);
      } else {
        console.error(`Unknown group ${group} in auth.groups`);
      }
    }
    return ls;
  },
);
